export enum AllocationMethod {
  REFERENCE_CODE = 'reference_code',
  ANAGRAM_REFERENCE_CODE = 'anagram_reference_code',
  PARTIAL_ANAGRAM_REFERENCE_CODE = 'partial_anagram_reference_code',
  PROVIDER_PAYMENT_ID = 'provider_payment_id',
  MANUAL = 'manual',
  AI_MATCH = 'ai_match'
}
